import Hero from './components/Hero/Hero';
import { ChakraProvider, Flex, Heading, Link, Stack } from '@chakra-ui/react';
import theme from './theme';
import Timeline from './components/Timeline';
import Projects from './components/Projects';
import Section from './components/Section';
import ImageText from './components/ImageText/ImageText';
import { EmailIcon } from '@chakra-ui/icons';
import { ReactComponent as LinkedIn } from './assets/icons/linkedin.svg';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <div className="App">
        <Hero />
        <Timeline />
        <Section props={{ bg: "linear-gradient(to right, var(--chakra-colors-gray-50), transparent)" }}>
          <ImageText />
        </Section>
        <Section>
          <Projects />
        </Section>
        <Section>
          <Stack gap="4">
            <Heading as="h3" fontSize={["2xl", "3xl"]} textAlign="center">Grab a coffee?</Heading>
            <Flex gap={{ base: "2", lg: "5" }} justifyContent="center" alignItems="center" flexDirection={{ base: "column", lg: "row" }}>
              <Flex alignItems="center" gap="2">
                <EmailIcon color="primary.1" w="24px" h="24px" />
                <Link href="mailto: cicci.lagerwall@gmail.com" color="primary.1">cicci.lagerwall@gmail.com</Link>
              </Flex>
              <Flex alignItems="center" gap="2">
                <LinkedIn fill="#D0A698" w="24px" h="24px" />
                <Link href="https://www.linkedin.com/in/cecilialagerwall/" color="primary.1">LinkedIn</Link>
              </Flex>
            </Flex>
          </Stack>
        </Section>
      </div>
    </ChakraProvider >
  );
}

export default App;
